<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class="container-fluid alert-fixed message-wrapper" *ngIf="(appStrings$ | async) as appStrings">
    <div class="d-flex justify-content-center flex-column align-items-center message-container"
         *ngIf="(messages$ | async) as items">
        <div *ngFor="let message of items"
             (click)="close(message)"
             class="message {{ message.type }} alert-dismissible fade show shadow"
             [@fade]
             role="alert">
            <ng-container *ngIf="message.labelKey">{{appStrings[message?.labelKey] || message?.defaultText || message?.labelKey || ''}}</ng-container>
            <ng-container *ngIf="message.text && !message.labelKey">{{message.text}}</ng-container>
            <a (click)="close(message)" type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </a>
        </div>
    </div>
</div>
